import React from "react"
import { Link } from "gatsby"
import widont from "widont"

import Image from "../image"
import styles from "./textColumns.module.scss"

const Anchor = props => {
  // URL api not available on the server
  if (!props.link.url || typeof window === "undefined") {
    return props.children
  }
  const url = typeof window !== "undefined" ? new URL(props.link.url) : null
  const type = props.link.type
  const isExternal = type === "url"
  const externalProps = {
    target: "_blank",
    rel: "noopener noreferrer",
  }

  if (isExternal) {
    return (
      <a href={props.link.url} {...(isExternal ? externalProps : {})}>
        {props.children}
      </a>
    )
  } else {
    return <Link to={url.pathname}>{props.children}</Link>
  }
}

const Text = props => {
  const numOfColumns = props.data.columns.length
  const isTwoRows = props.data.twoRows
  let columnClass
  let sizes
  switch (numOfColumns) {
    case 1:
      columnClass = `column is-6-tablet is-4-desktop`
      sizes = `(min-width: 1424px) 422px, (min-width: 1024px) calc(33vw - 3rem), (min-width: 768px) calc(50vw - 3rem), calc(100vw - 2.5rem)`
      break
    case 2:
      columnClass = `column is-6-tablet is-5-desktop`
      sizes = `(min-width: 1424px) 537px, (min-width: 1024px) calc(42vw - 3rem), (min-width: 768px) calc(50vw - 3rem), calc(100vw - 2.5rem)`
      break
    case 3:
      columnClass = `column is-4-tablet is-3-desktop`
      sizes = `(min-width: 1424px) 306px, (min-width: 1024px) calc(25vw - 3rem), (min-width: 768px) calc(33vw - 3rem), calc(100vw - 2.5rem)`
      break
    case 4:
      columnClass = `column ${
        isTwoRows ? "is-6-tablet is-5-desktop" : "is-6-tablet is-3-desktop"
      } `
      sizes = `(min-width: 1424px) 306px, (min-width: 1024px) calc(25vw - 3rem), (min-width: 768px) calc(50vw - 3rem), calc(100vw - 2.5rem)`
      break
    default:
      columnClass = ``
      sizes = ``
  }
  const subhead = props.data.subhead
  const heading = props.data.heading
  const body = props.data.body
  let leftAligned = false
  props.data.columns.map(col => {
    if (col.text) {
      leftAligned =
        !col.text.includes('style="text-align: center"') || leftAligned
    }
  })

  return (
    <div className="module">
      <div className="wrapper">
        {(subhead || heading || body) && (
          <div
            className={`header-container is-tablet is-0-mobile is-multiline ${
              leftAligned ? "extra-left-margin" : ""
            }`}
          >
            <div className={columnClass}>
              <div className={styles.content}>
                {subhead && (
                  <div className={styles.contentSubhead}>
                    <h2 className="subhead text-left">{widont(subhead)}</h2>
                  </div>
                )}
                {heading && (
                  <div className={styles.contentHeading}>
                    <h2 className="h-2 text-left">{widont(heading)}</h2>
                  </div>
                )}
                {body && (
                  <div
                    className="user-content"
                    dangerouslySetInnerHTML={{
                      __html: widont(body),
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        )}
        <div
          className={`columns is-tablet is-0-mobile is-centered is-multiline ${
            props.data.divider ? styles.hasDivider : ""
          } ${isTwoRows ? styles.isTwoRows : ""}`}
        >
          {props.data.columns &&
            props.data.columns.map(col => {
              return (
                <div key={`text-col-${col.id}`} className={columnClass}>
                  {col.image.length > 0 && (
                    <div className={styles.image}>
                      <Anchor link={col.imageLink}>
                        <Image
                          width={col.image[0].width}
                          height={col.image[0].height}
                          sizes={sizes}
                          url={col.image[0].url}
                          alt={col.image[0].altText}
                        />
                      </Anchor>
                    </div>
                  )}
                  {col.text && (
                    <div
                      className={`${styles.colBody} user-content`}
                      dangerouslySetInnerHTML={{
                        __html: widont(col.text),
                      }}
                    />
                  )}
                </div>
              )
            })}
        </div>
      </div>
    </div>
  )
}

export default Text
